// extracted by mini-css-extract-plugin
export default {"Row":"Container_Row__C-OO9","Column":"Container_Column__pIbxe","GoBack":"Container_GoBack__eIB7K"};